<div fxLayout="row" fxLayoutAlign="start start" ngClass.sm="layout padding-left-md" ngClass.md="layout padding-left-md">
  <a href="#" (click)="$event.preventDefault(); accountListNavigate()">
    <span fxHide.xs>Accounts</span>
    <mat-icon fxHide.gt-xs>chevron_left</mat-icon>
  </a>
  <mat-icon fxHide.xs>chevron_right</mat-icon>
  <span class="layout text-transform-uppercase" fxHide.xs>{{title}} </span>
  <span class="layout text-transform-uppercase" fxHide.gt-xs>{{title | truncate : 20}} </span>
</div>
